export default __webpack_public_path__ + "static/media/metaVerse.bee5b592.png";